export function generateTempPassword() {
  const part = Math.random().toString(36).slice(-8);
  return `Ts${part}!`;
}

export function displayUserName(user) {
  const legalName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return user.displayName?.trim() || legalName || user.email || '—';
}

export function userInitialsSource(user) {
  const legalName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return legalName || user.displayName?.trim() || user.email || '—';
}

export function userCellSecondaryLine(user) {
  const legalName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  const displayName = user.displayName?.trim() || '';
  const email = user.email || '';
  const primary = displayUserName(user);

  if (displayName && legalName && displayName !== legalName) {
    return email ? `${legalName} · ${email}` : legalName;
  }

  if (email && email !== primary) {
    return email;
  }

  return legalName && legalName !== primary ? legalName : '';
}
